// App-specific config
export default {
  title: 'VK Play',
  description: 'Description',
};
